import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { enviroments } from 'utils/constants';
import { getLocalStorageLanguage } from 'utils/utils';

const CURRENT_LANGUAGE = getLocalStorageLanguage();
export const eventsServiceApi = createApi({
  reducerPath: 'eventsServiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: enviroments.endPoint,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set(
        'Authorization',
        'Bearer ' + JSON.parse(localStorage.getItem('userAccountInformation') || '{}').bearerToken,
      );
      return headers;
    },
  }),
  endpoints: (builder) => ({
    GetEvents: builder.query<any, any>({
      query: ({ page, perPage, language = CURRENT_LANGUAGE, eventDate }) =>
        `event/?pageNumber=${page}&elementsPerPage=${perPage}&locale=${language}${eventDate}`,
    }),
    GetEventCategories: builder.query<any, any>({
      query: ({language = CURRENT_LANGUAGE}) => 'event/category?locale=' + language,
    }),
    GetEventById: builder.query<any, any>({
      query: ({ id, language = CURRENT_LANGUAGE }) => `event/${id}?locale=${language}`,
    }),
    GetSearchEvents: builder.query<any, any>({
      query: ({ language = CURRENT_LANGUAGE, txt }) => `event/search?locale=${language}&txt=${txt}`,
    }),
    GetEventsByCategoryId: builder.query<any, any>({
      query: ({ categoryId, language = CURRENT_LANGUAGE, pageNumber, elementsPerPage, eventDate = '' }) => `event/?${categoryId && `categoryId=${categoryId}&`}locale=${language}&pageNumber=${pageNumber}&elementsPerPage=${elementsPerPage}${eventDate}`,
    }),
    CheckShowEvents: builder.query<any, any>({
      query: () => 'event/viewevents',
    }),
  }),
});

export const { useLazyGetEventsQuery, useLazyGetEventCategoriesQuery, useLazyGetEventByIdQuery, useLazyGetEventsByCategoryIdQuery, useLazyGetSearchEventsQuery, useLazyCheckShowEventsQuery } =
  eventsServiceApi;
